<script setup lang="ts">
import { useRouter } from "vue-router";
import CustomButton from "@comp-lib/components/CustomButton.vue";
import { computed } from "vue";
import beeHiveImg from "@/assets/img/bee-hive.jpg";
import beeZoomingImg from "@/assets/img/bee-zooming.jpg";

const props = defineProps<{
  requireStandardPlan?: boolean;
}>();

const router = useRouter();

const imgSrc = computed(() => {
  return props.requireStandardPlan ? beeHiveImg : beeZoomingImg;
});
</script>

<template>
  <div class="setup-prompt">
    <img :src="imgSrc" :class="props.requireStandardPlan ? 'hive' : 'bee'" alt="Bees zooming around their hive">
    <p class="text">
      <template v-if="props.requireStandardPlan">
        To enjoy this feature, upgrade to the Standard plan. Lots of exciting perks and features await&nbsp;you!
        <CustomButton label="Upgrade now" @click="router.push({ name: 'UpdatePlan' })" />
      </template>

      <template v-else>Please complete both your ConnectWise PSA and QuickBooks Online setups to enjoy the full functionality of&nbsp;Mobius.</template>
    </p>
  </div>
</template>

<style scoped lang="scss">
.setup-prompt {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 30px;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 70px 20px;
  font-size: 1.125rem;
  line-height: 1.6;
  color: map.get(v.$gray, "500");
  background-color: white;
  border: 1px solid map.get(v.$gray, "300");
  border-radius: map.get(v.$border-radius, "sm");
  img.bee {
    max-width: 300px;
  }
  img.hive {
    max-width: 400px;
  }
  .text {
    max-width: 600px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
  }
}
</style>
